
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { Analytics } from '@vercel/analytics/react';
import posthog from 'posthog-js';
import App from './App.tsx';
import './index.css';

if (import.meta.env.PROD) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    person_profiles: 'identified_only', // only create profiles for identified (logged-in) users
    capture_pageview: false,            // we fire $pageview manually with React Router
  });
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

// Security enhancement: Redirect to HTTPS in production
if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.href = window.location.href.replace('http:', 'https:');
}

// Simplified security for mobile compatibility
const initializeSecurity = () => {
  // Only add basic security headers for mobile compatibility
  const headers = [
    { httpEquiv: 'X-Content-Type-Options', content: 'nosniff' },
    { httpEquiv: 'Referrer-Policy', content: 'strict-origin-when-cross-origin' }
  ];
  
  headers.forEach(header => {
    if (!document.querySelector(`meta[http-equiv="${header.httpEquiv}"]`)) {
      const meta = document.createElement('meta');
      meta.httpEquiv = header.httpEquiv;
      meta.content = header.content;
      document.head.appendChild(meta);
    }
  });
};

// Initialize security features
initializeSecurity();

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Analytics />
  </>
);
